import { makeVar, ReactiveVar } from '@apollo/client'
import { IArtist } from 'shared/interfaces'
import { SORT_OPTIONS } from 'modules/Projects/constants'
import { mergePagination } from 'shared/utils/storePagination'
import { PROJECT_FILTER_INIT_VALUES, PROJECT_FILTER_STORAGE_NAME } from 'shared/consts/filter'
import { getFiltersFromLocalStorage } from 'shared/utils/filters'

export const ProjectStore = {
  sortType: {
    read: () => sortTypeVar()
  },
  projectsList: {
    read: () => projectsListVar()
  },
  projectsFilters: {
    read() {
      return projectsFiltersVar()
    }
  },
  projectsTotal: {
    read: () => projectsTotalVar()
  },
  projectsOffset: {
    read: () => projectsOffsetVar()
  },
  getCampaigns: {
    keyArgs: [],
    merge: (existing: any = [], incoming: any, { args: { offset } }: any) =>
      mergePagination('artists', existing, incoming, offset)
  },
  activeProjectTab: {
    read: () => activeProjectTabVar()
  },
  activeGlobalizeProjectTab: {
    read: () => activeGlobalizeProjectTabVar()
  },
  activeGlobalProjectTab: {
    read: () => activeGlobalProjectTabVar()
  }
}

export const projectsListVar: ReactiveVar<IArtist[]> = makeVar<IArtist[]>([])
export const projectsTotalVar: ReactiveVar<number> = makeVar<number>(0)
export const projectsOffsetVar: ReactiveVar<number> = makeVar<number>(0)
export const projectsFiltersVar: ReactiveVar<any> = makeVar<any>(
  getFiltersFromLocalStorage(PROJECT_FILTER_STORAGE_NAME, PROJECT_FILTER_INIT_VALUES)
)

export const sortTypeVar: ReactiveVar<boolean> = makeVar<boolean>(SORT_OPTIONS.BY_DATE)
export const activeProjectTabVar: ReactiveVar<string> = makeVar<string>('stories')
export const activeGlobalizeProjectTabVar: ReactiveVar<string> = makeVar<string>('stories')
export const activeGlobalProjectTabVar: ReactiveVar<string> = makeVar<string>('stories')
